import React, { useLayoutEffect, useRef, useState } from "react"
import { FormattedMessage } from "react-intl"
import { WingsButton } from "../buttons"
import { WingsText } from "./WingsTypography"
import { htmlToTextWithBreaks } from "../../../../utils"

const ViewMore = ({ html, length, className="" }) => {
  const text = htmlToTextWithBreaks(html)
  const [isExpanded, setIsExpanded] = useState(false)
  const buttonRef = useRef(null)
  const shouldScrollToTopRef = useRef(false)

  useLayoutEffect(() => {
    if (!shouldScrollToTopRef.current || isExpanded) {
      return
    }

    const buttonElement = buttonRef.current
    if (buttonElement) {
      const buttonRect = buttonElement.getBoundingClientRect()
      const top = window.scrollY + buttonRect.top - (window.innerHeight / 2) + (buttonRect.height / 2)
      window.scrollTo({ top, behavior: "smooth" })
    }

    shouldScrollToTopRef.current = false
  }, [isExpanded])

  const handleToggle = () => {
    if (isExpanded) {
      shouldScrollToTopRef.current = true
    }

    setIsExpanded(!isExpanded)
  }

  if (text.length <= length) {
    return <WingsText>{text}</WingsText>
  }

  return (
    <WingsText className={className}>
      {isExpanded ? text : text.slice(0, length) + '...'}{' '}
      <WingsButton
        inline={true}
        variant="tertiary"
        onClick={handleToggle}
        buttonRef={buttonRef}
        size="small"
      >
        {isExpanded ? <FormattedMessage id="view-less" defaultMessage="View Less" /> : <FormattedMessage id="view-more" defaultMessage="View More" />}
      </WingsButton>
    </WingsText>
  )
}

export default ViewMore
